import React from 'react';
import { Pressable } from 'react-native';
import { XStack } from '@usepepper/sprout-kit-ui';

interface OrderEntryMobileHeaderPanelIconButtonProps {
  accessibilityLabel: string;
  children: React.ReactNode;
  onPress: () => void;
}

export const OrderEntryMobileHeaderPanelIconButton: React.FC<
  OrderEntryMobileHeaderPanelIconButtonProps
> = ({ accessibilityLabel, children, onPress }) => (
  <Pressable
    accessibilityLabel={accessibilityLabel}
    accessibilityRole="button"
    onPress={onPress}
  >
    <XStack
      alignItems="center"
      backgroundColor="$bgSecondaryDefault"
      borderRadius="$round"
      height="$32"
      justifyContent="center"
      marginTop="$4"
      width="$32"
    >
      <>{children}</>
    </XStack>
  </Pressable>
);
